import { isNil } from 'lodash';
import { centsToDollars } from '@mm/utils';
import { CouponObject } from '@mm/state/controllers/SubscriptionsController';
import {
  EnhancedPlan,
  PlansAllotments,
} from '@mm/state/interfaces/subscription';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import { getProRatedAmount } from '../checkout-form-helpers';
import { getPlanPrice } from '@mm/state/helpers/get-plan-price';

// tslint:disable-next-line: cyclomatic-complexity
export const getPriceByPlan = ({
  plan,
  allPlansAllotments,
  coupon,
  futurePaymentCredits,
  currentSubscription,
  downgradeFromSubscriptionId,
}: {
  plan: EnhancedPlan;
  allPlansAllotments: PlansAllotments;
  coupon: CouponObject | undefined;
  futurePaymentCredits?: number;
  currentSubscription?: SubscriptionModel;
  downgradeFromSubscriptionId?: number;
}) => {
  const {
    sendAllotmentAddOnPrice = 0,
    userSeatsAddOnPrice,
    smsNumberAddOnPrice,
  } = plan;

  const currentUserSeatsValue = currentSubscription
    ? isNil(currentSubscription.userSeats)
      ? -1
      : currentSubscription.userSeats || 0
    : 1;

  const exctraUserSeatsLeft =
    currentUserSeatsValue - plan.userSeats > 0
      ? currentUserSeatsValue - plan.userSeats
      : 0;
  const newUserSeatsValue = isNil(plan.userSeats)
    ? -1
    : plan.userSeats
    ? plan.userSeats + exctraUserSeatsLeft
    : 0;

  const currentUserSeatsPrice = currentSubscription
    ? (currentSubscription.userSeatAddOnPrice || 0) *
      (currentSubscription.extraUserSeats || 0)
    : 0;
  const newUserSeatsPrice =
    exctraUserSeatsLeft * (currentSubscription ? userSeatsAddOnPrice || 0 : 0);

  const currentSendCreditsValue = currentSubscription
    ? currentSubscription.maxSendAllotment
      ? currentSubscription.maxSendAllotment
      : -1
    : 1000;

  const extraSendCreditsValue =
    currentSendCreditsValue && allPlansAllotments[plan.planCode]
      ? currentSendCreditsValue - allPlansAllotments[plan.planCode].start
      : 0;

  const newSendCreditsValue = allPlansAllotments[plan.planCode]
    ? extraSendCreditsValue > 0
      ? allPlansAllotments[plan.planCode].start + extraSendCreditsValue
      : allPlansAllotments[plan.planCode].start
    : plan.outgoingMessagesLimit || -1;

  const currentSendCreditsPrice = currentSubscription
    ? (currentSubscription.sendAllotmentLevel || 0) *
      currentSubscription.sendAllotmentAddOnPrice
    : 0;

  const newSendCreditsPrice =
    extraSendCreditsValue * (currentSubscription ? sendAllotmentAddOnPrice : 0);

  const currentMonthlyFee = currentSubscription
    ? Number(centsToDollars(currentSubscription.unitAmountInCents))
    : 0;

  const newMonthlyFee =
    Number(centsToDollars(getPlanPrice(plan.unitAmountInCents, coupon))) +
    newSendCreditsPrice +
    newUserSeatsPrice;
  const proRateAmount = getProRatedAmount(currentSubscription);

  const proRatedAmount =
    currentSubscription?.priceFactor && currentSubscription?.priceFactor < 0
      ? null
      : proRateAmount
      ? Number(centsToDollars(proRateAmount)) || 0
      : 0;

  const smsNumberCount = currentSubscription?.smsNumbers
    ? Object.values(currentSubscription.smsNumbers).filter(Boolean).length
    : 0;
  const currentSmsNumberPrice = smsNumberAddOnPrice
    ? smsNumberCount * smsNumberAddOnPrice
    : 0;

  const planPrice = plan.unitAmountInCents;

  const payNow =
    currentSubscription?.priceFactor && currentSubscription?.priceFactor < 0
      ? Number(centsToDollars(getPlanPrice(planPrice, coupon)))
      : proRatedAmount
      ? Number(centsToDollars(getPlanPrice(planPrice, coupon))) -
          proRatedAmount >
        0
        ? Number(centsToDollars(getPlanPrice(planPrice, coupon))) -
          proRatedAmount
        : 0
      : Number(centsToDollars(getPlanPrice(planPrice, coupon)));

  return {
    planPrice: planPrice || null,
    newSendCreditsValue,
    currentSendCreditsValue,
    currentMonthlyFee,
    currentUserSeatsValue,
    currentUserSeatsPrice,
    newUserSeatsPrice,
    newUserSeatsValue,
    currentSendCreditsPrice,
    newSendCreditsPrice,
    newMonthlyFee,
    payNow,
    proRatedAmount: proRatedAmount
      ? Math.abs(
          Number(centsToDollars(getPlanPrice(plan.unitAmountInCents, coupon))) -
            proRatedAmount,
        )
      : 0,
    proRatedAsCredit: futurePaymentCredits,
    smsNumberCount,
    newSmsNumberCount: null,
    newSmsNumberPrice: currentSmsNumberPrice,
    currentSmsNumberPrice: null,
    showAddCoupon: true,
  };
};
